export const label = 'font-medium block text-base font-body text-textDark';
export const spacer = 'mb-4';
